import React, { useState } from 'react';
import { FaCog, FaRocket, FaAtom, FaIndustry, FaLaptopCode, FaMicrochip, FaSolarPanel, FaRobot, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaCalculator, FaFlask, FaBrain, FaChartLine, FaGraduationCap, FaAward, FaSatellite, FaBolt } from 'react-icons/fa';

const TechnicalEngineeringPage = () => {
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [expandedExam, setExpandedExam] = useState(null);

  const organizations = [
    {
      id: 'upsc-ies',
      name: 'UPSC IES/ESE',
      fullName: 'Indian Engineering Services / Engineering Services Examination',
      icon: <FaCog />,
      established: '1947',
      type: 'Central Engineering Services',
      conductedBy: 'Union Public Service Commission',
      headquarters: 'New Delhi',
      description: 'Premier examination for recruitment of engineers to various engineering services and posts under Government of India',
      exams: [
        {
          name: 'IES/ESE (Engineering Services Examination)',
          posts: ['Central Engineering Service Group A', 'Central Electrical & Mechanical Engineering Service', 'Central Civil Engineering Service', 'Central Power Engineering Service', 'Telecommunication Engineering Service', 'Indian Defense Service of Engineers'],
          eligibility: 'B.E./B.Tech or equivalent in relevant engineering discipline',
          ageLimit: '21-30 years',
          salary: '₹56,100 - ₹2,25,000/month (Level 10 to Level 14)',
          grade: 'Group A - Gazetted Officer',
          examPattern: [
            { phase: 'Preliminary - Paper I', duration: '120 minutes', sections: 'General Studies & Engineering Aptitude (Objective)', total: '200 marks' },
            { phase: 'Preliminary - Paper II', duration: '180 minutes', sections: 'Engineering Discipline (Objective)', total: '300 marks' },
            { phase: 'Mains - Paper I', duration: '180 minutes', sections: 'Engineering Discipline Paper I (Descriptive)', total: '300 marks' },
            { phase: 'Mains - Paper II', duration: '180 minutes', sections: 'Engineering Discipline Paper II (Descriptive)', total: '300 marks' },
            { phase: 'Personality Test', duration: '30-45 minutes', sections: 'Interview', total: '200 marks' }
          ],
          disciplines: ['Civil Engineering', 'Mechanical Engineering', 'Electrical Engineering', 'Electronics & Telecommunication Engineering'],
          syllabus: {
            generalStudies: ['Current Affairs', 'Indian Polity', 'Indian Economy', 'General Science', 'History', 'Geography', 'Environmental Issues'],
            engineeringAptitude: ['Engineering Mathematics', 'General Engineering', 'Engineering Mechanics', 'Strength of Materials', 'Theory of Structures'],
            civilEngineering: ['Structural Engineering', 'Geotechnical Engineering', 'Water Resources', 'Environmental Engineering', 'Transportation Engineering', 'Survey', 'Construction Management'],
            mechanicalEngineering: ['Theory of Machines', 'Thermodynamics', 'Heat Transfer', 'IC Engines', 'Manufacturing', 'Industrial Engineering', 'Fluid Mechanics'],
            electricalEngineering: ['Power Systems', 'Control Systems', 'Electrical Machines', 'Power Electronics', 'Analog & Digital Electronics', 'Measurements'],
            electronicsEngineering: ['Electronic Devices', 'Analog Circuits', 'Digital Electronics', 'Control Systems', 'Communication Systems', 'Electromagnetics', 'Microprocessors']
          },
          responsibilities: ['Project planning & execution', 'Technical supervision', 'Policy formulation', 'Infrastructure development', 'Quality control', 'Team management', 'Budget management'],
          careerPath: 'Assistant Executive Engineer → Executive Engineer → Superintending Engineer → Chief Engineer → Engineer-in-Chief',
          ministries: ['Railways', 'Defence', 'Power', 'Telecommunications', 'Border Roads', 'Central PWD', 'Military Engineer Services']
        }
      ],
      benefits: ['Central Government employee status', 'Gazetted officer perks', 'Official accommodation', 'Vehicle allowance', 'LTC benefits', 'Medical facilities', 'Pension & gratuity', 'Deputation opportunities']
    },
    {
      id: 'isro',
      name: 'ISRO',
      fullName: 'Indian Space Research Organisation',
      icon: <FaRocket />,
      established: '1969',
      type: 'Space Research Organization',
      headquarters: 'Bengaluru',
      description: 'India\'s national space agency conducting space research and planetary exploration',
      exams: [
        {
          name: 'ISRO Scientist/Engineer - SC',
          posts: ['Scientist/Engineer - SC (Electronics, Computer Science, Mechanical, Electrical, Civil, etc.)'],
          eligibility: 'B.E./B.Tech (First Class with 65% or CGPA 6.84/10) OR M.Tech/M.E. (First Class)',
          ageLimit: '35 years',
          salary: '₹56,100 - ₹1,77,500/month (Level 10)',
          grade: 'Scientist/Engineer - SC',
          examPattern: [
            { phase: 'Written Test', duration: '90 minutes', sections: 'Engineering & Aptitude (80 questions - MCQ)', total: '80 marks' },
            { phase: 'Interview', duration: '30-45 minutes', sections: 'Technical & HR Interview', total: 'Qualifying' }
          ],
          syllabus: {
            electronics: ['Analog Circuits', 'Digital Electronics', 'Control Systems', 'Communication Engineering', 'Microprocessors', 'VLSI', 'Electromagnetics'],
            computerScience: ['Programming & Data Structures', 'Algorithms', 'Operating Systems', 'DBMS', 'Computer Networks', 'Computer Organization', 'Theory of Computation'],
            mechanical: ['Engineering Mechanics', 'Strength of Materials', 'Thermodynamics', 'Fluid Mechanics', 'Heat Transfer', 'Manufacturing', 'Industrial Engineering'],
            electrical: ['Network Theory', 'Control Systems', 'Electrical Machines', 'Power Systems', 'Analog & Digital Electronics', 'Signals & Systems'],
            civil: ['Structural Analysis', 'Geotechnical Engineering', 'Fluid Mechanics', 'Environmental Engineering', 'Transportation Engineering', 'Construction Materials']
          },
          responsibilities: ['Satellite design & development', 'Launch vehicle systems', 'Space applications', 'Research & development', 'Mission planning', 'Technical documentation'],
          careerPath: 'Scientist/Engineer - SC → SD → SE → SF → SG → Outstanding Scientist',
          centers: ['VSSC Thiruvananthapuram', 'SDSC SHAR', 'ISAC Bengaluru', 'SAC Ahmedabad', 'IIRS Dehradun', 'NRSC Hyderabad']
        },
        {
          name: 'ISRO Technical Assistant',
          posts: ['Technical Assistant (Electronics, Mechanical, Computer Science, Electrical, Fitter)'],
          eligibility: 'Diploma/B.Sc./3-year Diploma in relevant discipline',
          ageLimit: '35 years',
          salary: '₹44,900 - ₹1,42,400/month (Level 6)',
          grade: 'Technical Assistant',
          examPattern: [
            { phase: 'Written Test', duration: '90 minutes', sections: 'Technical + General Awareness + Reasoning + Quantitative', total: '80 marks' },
            { phase: 'Skill Test', duration: 'Varies', sections: 'Practical test in respective discipline', total: 'Qualifying' }
          ],
          responsibilities: ['Technical support', 'Equipment maintenance', 'Testing & calibration', 'Documentation', 'Lab operations'],
          careerPath: 'Technical Assistant → Technical Officer → Senior Technical Officer'
        }
      ],
      projects: ['Chandrayaan', 'Mangalyaan', 'Gaganyaan', 'PSLV', 'GSLV', 'NavIC', 'Aditya-L1', 'XPoSat'],
      benefits: ['Work on space missions', 'International collaborations', 'Research opportunities', 'Best-in-class facilities', 'Performance-based incentives', 'Medical facilities', 'Residential campus']
    },
    {
      id: 'drdo',
      name: 'DRDO',
      fullName: 'Defence Research and Development Organisation',
      icon: <FaAtom />,
      established: '1958',
      type: 'Defence Research Agency',
      headquarters: 'New Delhi',
      description: 'Premier R&D organization working under Ministry of Defence for military technology development',
      exams: [
        {
          name: 'DRDO CEPTAM (Senior Technical Assistant B)',
          posts: ['Senior Technical Assistant B (STA-B)'],
          eligibility: 'B.E./B.Tech in relevant discipline OR M.Sc. in Physics/Chemistry/Mathematics/Statistics',
          ageLimit: '28 years',
          salary: '₹44,900 - ₹1,42,400/month (Level 6)',
          grade: 'STA-B',
          examPattern: [
            { phase: 'Tier I', duration: '90 minutes', sections: 'General Intelligence, General Awareness, Quantitative Aptitude, English', total: '200 marks' },
            { phase: 'Tier II', duration: '120 minutes', sections: 'Multi-Disciplinary Technical Paper', total: '400 marks' }
          ],
          disciplines: ['Computer Science', 'Electronics', 'Mechanical', 'Electrical', 'Civil', 'Physics', 'Chemistry', 'Mathematics'],
          responsibilities: ['Research support', 'Lab experiments', 'Data analysis', 'Equipment maintenance', 'Documentation', 'Technical assistance'],
          careerPath: 'STA-B → Scientist B → Scientist C → Scientist D → Scientist E → Scientist F → Scientist G'
        },
        {
          name: 'DRDO Entry through GATE',
          posts: ['Scientist B (via GATE score)'],
          eligibility: 'B.E./B.Tech/B.Sc. Engineering with valid GATE score',
          ageLimit: '28 years (extended for reserved categories)',
          salary: '₹56,100 - ₹1,77,500/month (Level 10)',
          grade: 'Scientist B',
          examPattern: [
            { phase: 'GATE Score', duration: 'N/A', sections: 'Valid GATE score in relevant discipline', total: 'Shortlisting' },
            { phase: 'Interview', duration: '30-45 minutes', sections: 'Technical & HR Interview', total: 'Final Selection' }
          ],
          syllabus: {
            gateSubjects: ['Engineering Mathematics', 'Core Engineering Subjects', 'Aptitude', 'Reasoning'],
            interviewTopics: ['Project work', 'Technical knowledge', 'Research aptitude', 'Communication skills', 'Current affairs in defence']
          },
          responsibilities: ['Defence technology research', 'Weapon system development', 'Design & testing', 'Innovation projects', 'Strategic R&D', 'Collaborative research'],
          careerPath: 'Scientist B → Scientist C → Scientist D → Scientist E → Scientist F → Scientist G → Outstanding Scientist → Distinguished Scientist',
          laboratories: ['50+ DRDO labs across India in Aeronautics, Electronics, Missiles, Armaments, Naval, Life Sciences, etc.']
        },
        {
          name: 'DRDO RAC (Research Associate)',
          posts: ['Research Associate (RA) - Post-doctoral position'],
          eligibility: 'Ph.D. in relevant Engineering/Science discipline',
          ageLimit: '35 years',
          salary: '₹54,000/month (Consolidated)',
          grade: 'Research Associate',
          examPattern: [
            { phase: 'Application Review', duration: 'N/A', sections: 'Academic credentials & research work', total: 'Shortlisting' },
            { phase: 'Interview', duration: '45-60 minutes', sections: 'Research presentation & technical interview', total: 'Final Selection' }
          ],
          responsibilities: ['Advanced research', 'Publication of papers', 'Project leadership', 'Technology transfer', 'Mentoring', 'Innovation'],
          careerPath: 'Research Associate → Scientist C (upon regularization)'
        }
      ],
      domains: ['Aeronautics', 'Armaments', 'Electronics & Communication', 'Life Sciences', 'Materials', 'Missiles', 'Naval Systems', 'Advanced Computing'],
      benefits: ['Work on cutting-edge defence technology', 'National importance projects', 'Research publications', 'Patent opportunities', 'International collaborations', 'Job security', 'Medical & accommodation']
    },
    {
      id: 'barc',
      name: 'BARC',
      fullName: 'Bhabha Atomic Research Centre',
      icon: <FaAtom />,
      established: '1954',
      type: 'Nuclear Research Facility',
      headquarters: 'Mumbai',
      description: 'India\'s premier nuclear research facility under Department of Atomic Energy',
      exams: [
        {
          name: 'BARC OCES/DGFS',
          posts: ['Scientific Officer (SO) - Training School Programs'],
          eligibility: 'B.E./B.Tech (First Class with 60%) in relevant discipline',
          ageLimit: '26 years',
          salary: '₹44,900 - ₹1,42,400/month (during training) → ₹56,100 - ₹1,77,500 (after confirmation)',
          grade: 'Scientific Officer/A → Scientific Officer/H',
          examPattern: [
            { phase: 'Written Test', duration: '180 minutes', sections: 'Engineering/Science subjects (200 marks) + Common subjects including Engg. Maths & English (100 marks)', total: '300 marks' },
            { phase: 'Interview', duration: '30-45 minutes', sections: 'Technical & Personal Interview', total: 'Qualifying' }
          ],
          programs: [
            { name: 'OCES (One Year Course for Engineering Graduates)', disciplines: ['Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Computer Science', 'Civil', 'Metallurgy', 'Chemical'] },
            { name: 'DGFS (Two Year Course for M.Sc.)', disciplines: ['Physics', 'Chemistry'] }
          ],
          syllabus: {
            mechanical: ['Thermodynamics', 'Fluid Mechanics', 'Heat Transfer', 'Manufacturing', 'Material Science', 'Strength of Materials', 'Engineering Design'],
            electrical: ['Circuit Theory', 'Control Systems', 'Power Systems', 'Power Electronics', 'Electrical Machines', 'Measurements'],
            electronics: ['Analog Electronics', 'Digital Electronics', 'Microprocessors', 'Communication Systems', 'Control Systems', 'Electromagnetics'],
            computerScience: ['Programming', 'Data Structures', 'Algorithms', 'OS', 'DBMS', 'Computer Networks', 'Software Engineering'],
            chemistry: ['Inorganic Chemistry', 'Organic Chemistry', 'Physical Chemistry', 'Analytical Chemistry', 'Nuclear Chemistry'],
            physics: ['Classical Mechanics', 'Quantum Mechanics', 'Thermodynamics', 'Electronics', 'Nuclear Physics', 'Solid State Physics']
          },
          training: {
            duration: '1 year (OCES) / 2 years (DGFS)',
            location: 'BARC Training School, Mumbai',
            stipend: 'During training period',
            subjects: ['Nuclear science & technology', 'Reactor engineering', 'Safety systems', 'Radiation protection', 'Specialized engineering']
          },
          responsibilities: ['Nuclear reactor operations', 'Research & development', 'Safety analysis', 'Fuel cycle management', 'Radiation protection', 'Advanced technology development'],
          careerPath: 'Scientific Officer/A → SO/B → SO/C → SO/D → SO/E → SO/F → SO/G → SO/H (Outstanding Scientist)',
          facilities: ['40+ research reactors and critical facilities', 'World-class R&D infrastructure', 'International collaborations']
        },
        {
          name: 'BARC Technical Officer',
          posts: ['Technical Officer (TO)'],
          eligibility: 'B.Sc. with 60% in relevant discipline OR Diploma in Engineering',
          ageLimit: '25 years',
          salary: '₹35,400 - ₹1,12,400/month (Level 5)',
          grade: 'Technical Officer',
          examPattern: [
            { phase: 'Written Exam', duration: '120 minutes', sections: 'Subject knowledge + General Aptitude', total: '200 marks' },
            { phase: 'Skill Test', duration: 'Varies', sections: 'Practical/Computer test', total: 'Qualifying' }
          ],
          responsibilities: ['Technical support', 'Lab operations', 'Equipment handling', 'Data recording', 'Maintenance', 'Safety compliance'],
          careerPath: 'Technical Officer → Senior Technical Officer → Scientific Assistant'
        }
      ],
      projects: ['Nuclear power programs', 'Advanced reactors', 'Thorium research', 'Desalination', 'Medical isotopes', 'Materials research'],
      benefits: ['Work in nuclear science', 'DAE facilities', 'Research opportunities', 'International exposure', 'Township accommodation', 'Medical facilities', 'Education allowance']
    },
    {
      id: 'psu',
      name: 'PSU Recruitments',
      fullName: 'Public Sector Undertakings',
      icon: <FaIndustry />,
      established: 'Various',
      type: 'Government Companies',
      description: 'Major PSUs recruiting engineers through GATE and their own exams',
      exams: [
        {
          name: 'GATE-based PSU Recruitment',
          posts: ['Management Trainee (Technical)', 'Executive Trainee', 'Engineer', 'GET (Graduate Engineer Trainee)'],
          eligibility: 'B.E./B.Tech with valid GATE score (usually above 60 percentile)',
          ageLimit: '18-30 years (varies by PSU)',
          salary: '₹40,000 - ₹1,60,000/month (varies by PSU and position)',
          grade: 'E1/E2 Grade',
          examPattern: [
            { phase: 'GATE Score', duration: 'N/A', sections: 'Valid GATE score for shortlisting', total: 'Shortlisting basis' },
            { phase: 'GD (if applicable)', duration: '20-30 minutes', sections: 'Group Discussion', total: 'Qualifying' },
            { phase: 'Interview', duration: '30-45 minutes', sections: 'Technical + HR Interview', total: '100-150 marks' }
          ],
          majorPSUs: [
            { name: 'NTPC', sector: 'Power', salary: '₹60,000 - ₹1,80,000/month' },
            { name: 'ONGC', sector: 'Oil & Gas', salary: '₹60,000 - ₹1,80,000/month' },
            { name: 'BHEL', sector: 'Heavy Electrical', salary: '₹50,000 - ₹1,60,000/month' },
            { name: 'IOCL', sector: 'Oil Refining', salary: '₹50,000 - ₹1,60,000/month' },
            { name: 'HPCL', sector: 'Petroleum', salary: '₹50,000 - ₹1,60,000/month' },
            { name: 'BPCL', sector: 'Petroleum', salary: '₹50,000 - ₹1,60,000/month' },
            { name: 'Coal India', sector: 'Mining', salary: '₹50,000 - ₹1,40,000/month' },
            { name: 'SAIL', sector: 'Steel', salary: '₹40,000 - ₹1,40,000/month' },
            { name: 'GAIL', sector: 'Natural Gas', salary: '₹60,000 - ₹1,80,000/month' },
            { name: 'Power Grid', sector: 'Power Transmission', salary: '₹50,000 - ₹1,70,000/month' },
            { name: 'HAL', sector: 'Aerospace', salary: '₹40,000 - ₹1,40,000/month' },
            { name: 'BEL', sector: 'Defence Electronics', salary: '₹40,000 - ₹1,40,000/month' }
          ],
          gateSubjects: ['Civil Engineering', 'Mechanical Engineering', 'Electrical Engineering', 'Electronics & Communication', 'Computer Science', 'Instrumentation', 'Chemical Engineering', 'Petroleum Engineering', 'Metallurgical Engineering'],
          responsibilities: ['Project execution', 'Operations & maintenance', 'Design & development', 'Quality control', 'Process optimization', 'Team management'],
          careerPath: 'E1 (GET/MT) → E2 (Engineer) → E3 (Senior Engineer) → E4 (Deputy Manager) → E5 (Manager) → E6 (Senior Manager) → E7 (Chief Manager) → E8 (General Manager) → E9 (Executive Director/CMD)'
        },
        {
          name: 'Individual PSU Exams (Non-GATE)',
          posts: ['Junior Engineer', 'Technician', 'Operator'],
          eligibility: 'Diploma/B.E./B.Tech depending on post',
          ageLimit: '18-30 years',
          salary: '₹25,000 - ₹80,000/month',
          grade: 'Junior/Assistant Grade',
          examPattern: [
            { phase: 'Written Exam', duration: '120-180 minutes', sections: 'Technical + Reasoning + English + GK', total: '150-200 marks' },
            { phase: 'Document Verification', duration: 'Varies', sections: 'Certificate verification', total: 'Qualifying' }
          ],
          responsibilities: ['Technical operations', 'Maintenance', 'Supervision', 'Documentation', 'Safety compliance'],
          careerPath: 'Junior Engineer → Engineer → Senior Engineer → Assistant Manager → Manager'
        }
      ],
      benefits: ['Excellent salary packages', 'Job security', 'Medical facilities for family', 'LTC', 'Performance bonuses', 'Residential quarters', 'Children education support', 'Retirement benefits', 'Deputation opportunities']
    },
    {
      id: 'nic-nielit',
      name: 'NIC / NIELIT',
      fullName: 'National Informatics Centre / National Institute of Electronics & Information Technology',
      icon: <FaLaptopCode />,
      established: '1976 / 1994',
      type: 'IT & Electronics Research',
      headquarters: 'New Delhi',
      description: 'Premier institutions for IT services and electronics & IT education',
      exams: [
        {
          name: 'NIC Scientist-B',
          posts: ['Scientist-B (Technical)'],
          eligibility: 'B.E./B.Tech/MCA in Computer Science/IT/Electronics OR M.Sc. in Computer Science/IT/Electronics',
          ageLimit: '30 years',
          salary: '₹56,100 - ₹1,77,500/month (Level 10)',
          grade: 'Scientist-B',
          examPattern: [
            { phase: 'Tier I (Screening)', duration: '120 minutes', sections: 'Computer Science & IT fundamentals (Objective)', total: '120 marks' },
            { phase: 'Tier II (Main)', duration: '180 minutes', sections: 'Advanced IT concepts (Descriptive)', total: '100 marks' },
            { phase: 'Interview', duration: '30 minutes', sections: 'Technical & Personality assessment', total: '50 marks' }
          ],
          syllabus: {
            computerScience: ['Programming & DS', 'Algorithms', 'DBMS', 'Operating Systems', 'Computer Networks', 'Web Technologies', 'Software Engineering', 'Information Security', 'Cloud Computing', 'Data Analytics'],
            electronics: ['Digital Electronics', 'Microprocessors', 'Computer Architecture', 'Communication Systems', 'Network Security']
          },
          responsibilities: ['E-Governance projects', 'Government portal development', 'Database management', 'Network administration', 'Cyber security', 'Technical support to ministries', 'Digital India initiatives'],
          careerPath: 'Scientist-B → Scientist-C → Scientist-D → Scientist-E → Scientist-F → Scientist-G',
          projects: ['Aadhaar', 'DigiLocker', 'e-Hospital', 'UMANG', 'Voter portal', 'Court Information Systems', 'Land Records Digitization']
        },
        {
          name: 'NIELIT Scientist-B',
          posts: ['Scientist-B (Technical)'],
          eligibility: 'B.E./B.Tech/MCA/M.Sc. in relevant discipline with 60%',
          ageLimit: '30 years',
          salary: '₹56,100 - ₹1,77,500/month (Level 10)',
          grade: 'Scientist-B',
          examPattern: [
            { phase: 'Written Exam', duration: '180 minutes', sections: 'Section A: Computer Science (100 marks), Section B: Electronics & Communication (50 marks), Section C: General Aptitude (50 marks)', total: '200 marks' },
            { phase: 'Interview', duration: '30 minutes', sections: 'Technical & HR', total: 'Qualifying' }
          ],
          syllabus: {
            computerScience: ['C, C++, Java', 'Data Structures', 'Algorithms', 'DBMS', 'OS', 'Networks', 'Web Technologies', 'Software Engineering', 'AI & ML basics'],
            electronics: ['Digital Electronics', 'Microprocessors', 'Communication Engineering', 'Embedded Systems'],
            generalAptitude: ['Reasoning', 'English', 'Quantitative Aptitude']
          },
          responsibilities: ['IT education & training', 'Curriculum development', 'Research projects', 'Skill development programs', 'Digital literacy', 'Industry collaborations'],
          careerPath: 'Scientist-B → Scientist-C → Scientist-D → Scientist-E → Scientist-F',
          centers: ['62 centers across India offering IT education and skill development']
        },
        {
          name: 'Technical Assistant',
          posts: ['Technical Assistant (Computer Science/Electronics)'],
          eligibility: 'B.Sc. in Computer Science/Electronics OR BCA OR B.E./B.Tech OR Diploma',
          ageLimit: '27 years',
          salary: '₹35,400 - ₹1,12,400/month (Level 5)',
          grade: 'Technical Assistant',
          examPattern: [
            { phase: 'Written Exam', duration: '120 minutes', sections: 'Technical + Reasoning + English + GK', total: '150 marks' },
            { phase: 'Typing Test', duration: '10 minutes', sections: '35 wpm English OR 30 wpm Hindi', total: 'Qualifying' }
          ],
          responsibilities: ['Technical support', 'Lab management', 'System administration', 'Training assistance', 'Documentation'],
          careerPath: 'Technical Assistant → Senior Technical Assistant → Assistant'
        }
      ],
      benefits: ['Central Government employee', 'Work on national IT projects', 'Skill development opportunities', 'Job security', 'Medical facilities', 'LTC', 'Pension']
    }
  ];

  const emergingTechnologies = [
    {
      title: 'Artificial Intelligence & Machine Learning',
      icon: <FaBrain />,
      topics: ['Deep Learning', 'Neural Networks', 'NLP', 'Computer Vision', 'Reinforcement Learning', 'AI Ethics'],
      applications: ['Autonomous systems', 'Predictive analytics', 'Smart automation', 'Pattern recognition'],
      opportunities: 'High demand in ISRO, DRDO, NIC, and all major PSUs'
    },
    {
      title: 'Robotics & Automation',
      icon: <FaRobot />,
      topics: ['Industrial Robotics', 'Mobile Robotics', 'Robot Operating System', 'Sensors & Actuators', 'Path Planning', 'Control Systems'],
      applications: ['Manufacturing automation', 'Space exploration', 'Defence applications', 'Healthcare'],
      opportunities: 'Critical for DRDO, HAL, ISRO, and manufacturing PSUs'
    },
    {
      title: 'Renewable Energy Systems',
      icon: <FaSolarPanel />,
      topics: ['Solar Energy', 'Wind Energy', 'Energy Storage', 'Smart Grid', 'Power Electronics', 'Energy Management'],
      applications: ['Solar power plants', 'Wind farms', 'Microgrids', 'Electric vehicles'],
      opportunities: 'Major recruitments in NTPC, Power Grid, ONGC, renewable energy PSUs'
    },
    {
      title: 'IoT & Embedded Systems',
      icon: <FaMicrochip />,
      topics: ['IoT Architecture', 'Embedded C', 'Microcontrollers', 'RTOS', 'Communication Protocols', 'Edge Computing'],
      applications: ['Smart cities', 'Industrial IoT', 'Defence systems', 'Space applications'],
      opportunities: 'High demand in BEL, ISRO, DRDO, and telecom PSUs'
    }
  ];

  const gatePreparation = {
    subjects: {
      engineeringMathematics: ['Linear Algebra', 'Calculus', 'Differential Equations', 'Probability & Statistics', 'Numerical Methods'],
      coreEngineering: ['Varies by discipline - 70% weightage', 'In-depth subject knowledge required', 'Previous year analysis crucial'],
      generalAptitude: ['Verbal Ability', 'Numerical Ability', 'Spatial Aptitude', 'English comprehension']
    },
    examPattern: {
      duration: '3 hours',
      totalMarks: 100,
      sections: [
        { name: 'General Aptitude', marks: 15, questions: 10 },
        { name: 'Engineering Mathematics', marks: 13, questions: 11 },
        { name: 'Core Engineering', marks: 72, questions: 44 }
      ],
      questionTypes: ['MCQ (1 & 2 marks)', 'NAT (Numerical Answer Type)'],
      negativMarking: 'Yes for MCQs, No for NAT'
    },
    strategy: [
      'Start preparation 12 months before exam',
      'Focus on fundamentals - NPTEL, standard textbooks',
      'Practice previous 15 years question papers',
      'Take 100+ mock tests',
      'Analyze weak areas and revise',
      'Focus on engineering mathematics - scoring section',
      'Keep answer key ready for negative marking',
      'Virtual calculator practice'
    ]
  };


   const comparison = [
    {
      title: 'UPSC IES vs GATE vs PSU vs ISRO',
      factors: [
        { parameter: 'Exam Authority', details: 'UPSC / IITs / Individual PSUs / ISRO' },
        { parameter: 'Level', details: 'National (Central Government)' },
        { parameter: 'Purpose', details: 'Recruitment for central engineering and research services' },
        { parameter: 'Eligibility', details: 'B.E./B.Tech or equivalent' },
        { parameter: 'Selection', details: 'Written + Interview (UPSC/ISRO/DRDO), GATE Score (PSUs)' },
        { parameter: 'Job Role', details: 'Engineering, Research, Technical Management' },
        { parameter: 'Perks', details: 'Housing, LTC, Medical, Pension, Government benefits' },
        { parameter: 'Promotion', details: 'Structured hierarchy with time-bound promotions' },
        { parameter: 'Work Area', details: 'Infrastructure, Defence, Space, IT, Power, Research' }
      ]
    }
  ];

  return (
    <div className="container my-5 py-5">
      <h2 className="text-center mb-4 fw-bold text-primary">
        Central Engineering & Technical Government Exams
      </h2>

      <p className="text-center text-muted mb-5">
        Explore detailed information, syllabus, roadmap, and preparation strategy for India’s top central engineering and scientific government organizations.
      </p>

      {/* Organizations Section */}
      {organizations.map((org) => (
        <div key={org.id} className="mb-5 p-4 border rounded shadow-sm bg-light col-9 mx-auto">
          <div
            className="d-flex justify-content-between align-items-center"
            onClick={() => setExpandedOrg(expandedOrg === org.id ? null : org.id)}
            style={{ cursor: 'pointer' }}
          >
            <h4 className="fw-bold text-dark mb-0">
              {org.icon} <span className="ms-2">{org.name}</span>
            </h4>
            {expandedOrg === org.id ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          {expandedOrg === org.id && (
            <div className="mt-3">
              <p className="text-muted"><strong>Full Name:</strong> {org.fullName}</p>
              <p><strong>Type:</strong> {org.type} | <strong>Headquarters:</strong> {org.headquarters}</p>
              <p>{org.description}</p>

              {/* Exams */}
              {org.exams.map((exam, index) => (
                <div key={index} className="mt-3 p-3 bg-white border rounded">
                  <h5 className="fw-semibold text-secondary">{exam.name}</h5>
                  <p><strong>Eligibility:</strong> {exam.eligibility}</p>
                  <p><strong>Age Limit:</strong> {exam.ageLimit}</p>
                  <p><strong>Salary:</strong> {exam.salary}</p>

                  <ul>
                    {exam.posts.map((post, i) => (
                      <li key={i}>{post}</li>
                    ))}
                  </ul>

                  <h6 className="fw-bold mt-3">Exam Pattern:</h6>
                  <ul>
                    {exam.examPattern.map((pattern, i) => (
                      <li key={i}>
                        <strong>{pattern.phase}</strong> — {pattern.sections} ({pattern.total})
                      </li>
                    ))}
                  </ul>

                  {exam.responsibilities && (
                    <>
                      <h6 className="fw-bold mt-3">Responsibilities:</h6>
                      <ul>
                        {exam.responsibilities.map((res, i) => <li key={i}>{res}</li>)}
                      </ul>
                    </>
                  )}

                  {exam.careerPath && (
                    <p><strong>Career Path:</strong> {exam.careerPath}</p>
                  )}
                </div>
              ))}

              <div className="mt-3">
                <h6 className="fw-bold text-success">Benefits:</h6>
                <ul>
                  {org.benefits.map((benefit, i) => <li key={i}>{benefit}</li>)}
                </ul>
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Emerging Technologies Section */}
      <div className="mt-5 col-9 mx-auto">
        <h3 className="fw-bold text-primary mb-3">Emerging Technologies in Engineering</h3>
        <div className="row">
          {emergingTechnologies.map((tech, index) => (
            <div key={index} className="col-md-6 mb-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h5 className="card-title text-dark fw-bold">
                    {tech.icon} <span className="ms-2">{tech.title}</span>
                  </h5>
                  <p className="text-muted mt-2">
                    <strong>Topics:</strong> {tech.topics.join(', ')}
                  </p>
                  <p><strong>Applications:</strong> {tech.applications.join(', ')}</p>
                  <p><strong>Opportunities:</strong> {tech.opportunities}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* GATE Preparation Section */}
      <div className="mt-5 col-10 mx-auto">
        <h3 className="fw-bold text-primary mb-3">GATE Exam Preparation Strategy</h3>
        <div className="card p-4 shadow-sm bg-light">
          <h5 className="text-secondary">Subjects</h5>
          <ul>
            <li><strong>Engineering Mathematics:</strong> {gatePreparation.subjects.engineeringMathematics.join(', ')}</li>
            <li><strong>Core Engineering:</strong> {gatePreparation.subjects.coreEngineering.join(', ')}</li>
            <li><strong>General Aptitude:</strong> {gatePreparation.subjects.generalAptitude.join(', ')}</li>
          </ul>

          <h5 className="text-secondary mt-3">Exam Pattern</h5>
          <ul>
            {gatePreparation.examPattern.sections.map((section, i) => (
              <li key={i}>
                {section.name}: {section.marks} marks ({section.questions} questions)
              </li>
            ))}
          </ul>

          <h5 className="text-secondary mt-3">Preparation Tips</h5>
          <ul>
            {gatePreparation.strategy.map((tip, i) => <li key={i}>{tip}</li>)}
          </ul>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="mt-5 mb-5 col-10 mx-auto">
        <h3 className="fw-bold text-primary mb-3">Exam Comparison Overview</h3>
        {comparison.map((comp, index) => (
          <div key={index} className="card p-3 shadow-sm">
            <h5 className="fw-bold text-dark mb-3">{comp.title}</h5>
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th>Parameter</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {comp.factors.map((fact, i) => (
                  <tr key={i}>
                    <td>{fact.parameter}</td>
                    <td>{fact.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnicalEngineeringPage;
